const textalignRight = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
      <g fill="none" fill-rule="evenodd" transform="translate(1 -1)">
        <path class="icon-text-align" stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round" d="M.416666667 17.9166667L19.5833333 17.9166667M3.75.416666667L19.5833333.416666667M6.25 2.91666667L19.5833333 2.91666667M3.75 5.41666667L19.5833333 5.41666667M.416666667 7.91666667L19.5833333 7.91666667M3.75 10.4166667L19.5833333 10.4166667M6.25 12.9166667L19.5833333 12.9166667M3.75 15.4166667L19.5833333 15.4166667" transform="translate(0 1.667)"/>
        <rect width="20" height="20"/>
      </g>
    </svg>

`;

export default textalignRight;
